import Draw from './SOUNDS/draw.mp3';
import Link1 from './SOUNDS/link1.mp3';
import Link2 from './SOUNDS/link2.mp3';
import Lost from './SOUNDS/lost.mp3';
import Player1Wins from './SOUNDS/Player1Wins.mp3';
import Player2Wins from './SOUNDS/Player2Wins.mp3';
import Score1 from './SOUNDS/score1.mp3';
import Score2 from './SOUNDS/score2.mp3';
import Dice from './SOUNDS/dice.mp3';
// import Dice2 from './SOUNDS/dice2.mp3';
import Tap from './SOUNDS/tap.mp3';
import Won from './SOUNDS/won.mp3';
import Coin1 from './SOUNDS/coin1.mp3';
import Coin2 from './SOUNDS/coin2.mp3';
import Coins from './SOUNDS/coins.mp3';
import Click from './SOUNDS/click.mp3';
import Cluck from './SOUNDS/cluck.mp3';
import Oops from './SOUNDS/oops.mp3';
import Drop from './SOUNDS/drop.mp3';
import { DEFAULT_VOLUME } from './const';

const sounds = {
  draw: new Audio(Draw),
  link1: new Audio(Link1),
  link2: new Audio(Link2),
  lost: new Audio(Lost),
  player1wins: new Audio(Player1Wins),
  player2wins: new Audio(Player2Wins),
  score1: new Audio(Score1),
  score2: new Audio(Score2),
  dice: new Audio(Dice),
  dice2: new Audio(Dice),
  tap: new Audio(Tap),
  won: new Audio(Won),
  coin1: new Audio(Coin1),
  coin2: new Audio(Coin2),
  coins: new Audio(Coins),
  click: new Audio(Click),
  cluck: new Audio(Cluck),
  oops: new Audio(Oops),
  drop: new Audio(Drop),
};

let current = null;

export const Sound = (name, volume) => {
  if (current) {
    // sounds[current].pause();
  }

  sounds[name].volume = volume <= 0 ? 0 : volume || DEFAULT_VOLUME;

  sounds[name].play();
  current = name;
};
